import { OrderRepository } from "../../../../data/repository/order/OrderRepository";
import { Order } from "../../../model/Order";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetOrderByIdUseCase {
  invoke: (id: string) => Promise<ResponseState<Order>>;
}

export class GetOrderByIdUseCaseImpl implements GetOrderByIdUseCase {
  private repository: OrderRepository;

  constructor(repository: OrderRepository) {
    this.repository = repository;
  }

  async invoke(id: string): Promise<ResponseState<Order>> {
    try {
      let response = await this.repository.getById(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
